'use client'

import { useBooking } from '@/contexts/BookingContext'
import { SeasonalDecorations } from './SeasonalDecorations'
import { effectiveSeasonalTheme } from '@/lib/national-day'

export function SeasonalDecorationsWrapper() {
  const { seasonalTheme } = useBooking()
  // A hotel's own theme wins; otherwise National Day week switches itself on.
  return <SeasonalDecorations theme={effectiveSeasonalTheme(seasonalTheme)} />
}
